export const getControlledMapTypeId = ({
  enableLayerPicker,
  selectedBaseMap,
  satelliteMapTypeId,
}) => (
  enableLayerPicker && selectedBaseMap === 'Google Maps Satellite'
    ? satelliteMapTypeId
    : 'roadmap'
);
